import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import { url, fileUploadUrl } from "../../../../constant";


const failureColumn = [
  {
    "id": 1,
    "icon": "regional",
    "title": "Why Choose BandiHub123",
    "description": "Accesso a bandi regionali, nazionali ed europei",

  },
  {
    "id": 2,
    "icon": "personalized",
    "title": "Why Choose BandiHub",
    "description": "Suggerimenti personalizzati in base al tuo settore",

  },
  {
    "id": 3,
    "icon": "notifications",
    "title": "Default Heading123",
    "description": "Maggiore probabilità di ottenere finanziamenti",

  },
  {
    "id": 4,
    "icon": null,
    "title": "Default Heading123",
    "description": "Risparmio di tempo nella ricerca di finanziamenti",

  },
  {
    "id": 5,
    "icon": null,
    "title": "Why Choose BandiHub",
    "description": "Notifiche automatiche per nuovi bandi",

  },
  {
    "id": 6,
    "icon": null,
    "title": "Why Choose BandiHub",
    "description": "Assistenza personalizzata tramite AI",

  }];


// const renderItem = (text) => (
//   <Box
//     key={text}
//     sx={{
//       display: 'flex',
//       alignItems: 'center',
//       mb: 4,
//     }}
//   >
//     {/* Circle with tick */}
//     <Box
//       sx={{
//         width: 28,
//         height: 28,
//         borderRadius: '50%',
//         border: '2px solid #1976d2',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         marginRight: 2,
//         flexShrink: 0,
//       }}
//     >
//       <CheckIcon sx={{ fontSize: 18, color: '#1976d2' }} />
//     </Box>

//     {/* Text */}
//     <Typography variant="body2">{text}</Typography>
//   </Box>
// );


const renderItem = (text, key) => (
  <Box
    key={key}
    sx={{
      display: 'flex',
      alignItems: 'center',
      mb: 4,
    }}
  >
    {/* Circle with tick */}
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: '2px solid #1976d2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 2,
        flexShrink: 0,
      }}
    >
      <CheckIcon sx={{ fontSize: 18, color: '#1976d2' }} />
    </Box>

    {/* Description text */}
    <Typography variant="body2">{text}</Typography>
  </Box>
);

const SelectionPanel = () => {

  const [loading, setLoading] = useState(false);
  const [heading, setHeading] = useState("");
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    fetchHeading();
    fetchFeatures();
  }, []);

  // Heading fetch karne ke liye
  const fetchHeading = () => {
    fetch(`${url}auth/bandihub-heading`)  // backend ka endpoint
      .then((res) => res.json())
      .then((data) => {
        setHeading(data.data || "Why Choose BandiHub");
      })
      .catch((err) => {
        console.error("Failed to fetch heading:", err)
        setHeading("Why Choose BandiHub");

      });
  };

  // Features fetch karne ke liye (same as before)
  const fetchFeatures = () => {
    setLoading(true);
    fetch(`${url}auth/get-bandihub-features`)
      .then((res) => res.json())
      .then((data) => {
        setFeatures(data.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch features:", err)
        setFeatures(failureColumn || []);
      })
      .finally(() => setLoading(false));
  };


  // Split features into two columns
  const midIndex = Math.ceil(features.length / 2);
  const column1 = features.slice(0, midIndex);
  const column2 = features.slice(midIndex);

  return (
    
    <Box
      sx={{
        // minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        // bgcolor: '#f9f9f9', // optional light background
      }}
    >

      

      <Box 
      maxWidth="xxl" 
      width="100%" 
      // mx="auto" 
      // sx={{ px: { xs: 2, sm: 3, md: 6, lg: 2, } }}
      
      >
        <Typography variant="h2" align="center" mb={7} gutterBottom>
          {/* Perché Scegliere <Box component="span" color="#1f77b4">BandiHub</Box> */}
          {heading && heading !== "" ? (() => {
            const words = heading.trim().split(" ");
            const lastWord = words.pop(); // Remove and store the last word
            const firstPart = words.join(" "); // Join the rest

            return (
              <>
                {firstPart && <>{firstPart} </>}
                <Box component="span" color="#1f77b4">{lastWord}</Box>
              </>
            );
          })() : (
            "Perché Scegliere BandiHub"
          )}
        </Typography>

        <Box
          sx={{ paddingLeft: '42px', paddingRight: '10px' }}
        > 

        <Grid container spacing={4} justifyContent="center" bgcolor={"#f0f8ff"}>
          <Grid item xs={12} md={6}>
            {/* {column1.map(renderItem)} */}
            {column1.map((feature, idx) => renderItem(feature.description, feature.id || idx))}
          </Grid>
          <Grid item xs={12} md={6}>
            {/* {column2.map(renderItem)} */}
            {column2.map((feature, idx) => renderItem(feature.description, feature.id || midIndex + idx))}
          </Grid>
        </Grid>

        </Box>
      </Box>
    </Box>
  );
};

export default SelectionPanel;
